import * as React from 'react';

import type { UserEmail } from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1/email_address';

import CatalogSection from 'bundles/enterprise-legacy-learner-home/components/single-program/CatalogSection';
import type { OnProductCardClick } from 'bundles/enterprise-legacy-learner-home/types/Products';
import EnterpriseHomeMyCoursesProgramContent from 'bundles/program-home/components/enterprise-home/EnterpriseHomeMyCoursesProgramContent';
import type {
  EnterpriseProgramFieldsFragment as EnterpriseProgram,
  ThirdPartyOrganizationFieldsFragment as ThirdPartyOrganization,
} from 'bundles/program-home/queries/__generated__/EnterpriseHomePageQuery';

type PropsFromCaller = {
  isVisible: boolean;
  onProductCardClick: OnProductCardClick;
  enterprisePrograms: EnterpriseProgram[];
  thirdPartyOrganization: ThirdPartyOrganization;
  userEmails: UserEmail[];
  userId: number;
};

export type Props = PropsFromCaller;

const EnterpriseHomeMyCoursesTabContent = ({
  isVisible,
  onProductCardClick,
  enterprisePrograms,
  thirdPartyOrganization,
  userEmails,
  userId,
}: Props) => (
  <div className="EnterpriseHomeMyCoursesTabContent" data-testid="enterprise-home-my-courses-tab-content">
    {enterprisePrograms.map((enterpriseProgram, index) => (
      <CatalogSection key={enterpriseProgram.id}>
        <EnterpriseHomeMyCoursesProgramContent
          isVisible={isVisible}
          lazy={index > 0}
          onProductCardClick={onProductCardClick}
          enterpriseProgram={enterpriseProgram}
          thirdPartyOrganization={thirdPartyOrganization}
          userEmails={userEmails}
          userId={userId}
        />
      </CatalogSection>
    ))}
  </div>
);

export default EnterpriseHomeMyCoursesTabContent;
